"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eleven/sections/blogsSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogsSection3446sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xxl-3 col-xl-4 col-lg-4 col-md-6" | "col-xxl-6 col-xl-4 col-lg-4 col-md-6" | "col-xxl-3 col-xl-4 col-lg-4 col-md-12" */
    className: string;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "blog-overlay" | "blog-overlay overlay-center" */
    div0ClassName: string;
    /** Detected variants: "25" | "30" | "08" */
    div0Text: ReactNode;
    /** Detected variants: "Nov" | "Dec" | "Jan" */
    span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/blog/blogs-img-1.jpg" | "/Templates/Doccure/img/blog/blogs-img-2.jpg" | "/Templates/Doccure/img/blog/blogs-img-3.jpg" */
    src: string;
    /** Detected variants: "/Templates/Doccure/img/patients/patient-20.jpg" | "/Templates/Doccure/img/patients/patient11.jpg" | "/Templates/Doccure/img/patients/patient-21.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "Grace Morgan" | "Ethan Brooks" | "Chloe Harper" */
    link0Text: ReactNode;
    /** Detected variants: "Surgery" | "Preparation" | "Aesthetics" */
    span0Span0Text: ReactNode;
    /** Detected variants: "Modern Cosmetic Surgery for Safer Results" | "Preparing Properly Before Undergoing Any Cosmetic Procedure" | "Advanced Non Surgical Treatments for Beauty" */
    link0Link0Text: ReactNode;
    /** Detected variants: "blog-item-eleven wow fadeInUp" */
    div0ClassName2?: string;
    /** Detected variants: "blog-date" */
    div0ClassName3?: string;
    /** Detected variants: "all_routes.blogDetails" */
    href?: string;
    /** Detected variants: "blogs" */
    alt?: string;
    /** Detected variants: "img-fluid blog-img" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "blog-author" */
    div0ClassName4?: string;
    /** Detected variants: "author" */
    div0ClassName5?: string;
    /** Detected variants: "avatar avatar-sm rounded-circle" */
    div0ClassName6?: string;
    /** Detected variants: "patient" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "link" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    link0Href?: string;
    /** Detected variants: "badge" */
    span0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href2?: string;
};
export type HomeElevenBlogsSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogsSection3446sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogsSection3446sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogsSection3446sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogsSection3446sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogsSection3446sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogsSection3446sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Articles" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-left.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-right.svg" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our Recent Blogs" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    blogsSection3446s: BlogsSection3446sItem[];
    blogsSection3446sItemWrapper?: (item: BlogsSection3446sItem, content: ReactNode) => ReactNode;
    blogsSection3446sRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogsSection3446sLinkVisible?: boolean;
    blogsSection3446sLinkRenderer?: (item: BlogsSection3446sItem, defaultNode: ReactNode) => ReactNode;
    blogsSection3446sImageVisible?: boolean;
    blogsSection3446sImageRenderer?: (item: BlogsSection3446sItem, defaultNode: ReactNode) => ReactNode;
    blogsSection3446sH3Visible?: boolean;
    blogsSection3446sH3Renderer?: (item: BlogsSection3446sItem, defaultNode: ReactNode) => ReactNode;
    blogsSection3446sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogsSection3446sItem) => Partial<ComponentProps<typeof SmartLink>>);
    blogsSection3446sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogsSection3446sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogsSection3446sH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogsSection3446sItem) => Partial<ComponentProps<"h3">>);
};

const HomeElevenBlogsSectionGenerated: FC<HomeElevenBlogsSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Articles",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/arrow-left.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/arrow-right.svg",
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0H20H2Text = "Our Recent Blogs",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    blogsSection3446s,
    blogsSection3446sItemWrapper,
    blogsSection3446sRenderer,
    blogsSection3446sLinkVisible,
    blogsSection3446sLinkRenderer,
    blogsSection3446sImageVisible,
    blogsSection3446sImageRenderer,
    blogsSection3446sH3Visible,
    blogsSection3446sH3Renderer,
    blogsSection3446sLinkProps,
    blogsSection3446sImageProps,
    blogsSection3446sH3Props,
}) => {
    return (
        <section className="blog-section-eleven section">
            <div className="container">
                <div className="section-header section-header-eleven text-center">
                    <div className="title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid icon-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid icon-2" {...(sectionDiv0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-5"}>
                    {renderCollectionNode(
                        blogsSection3446s,
                        (item: BlogsSection3446sItem) => (
                            <div className={item.className} key={item.key}>
                                <div className={item.div0ClassName2 ?? "blog-item-eleven wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName}>
                                        {renderItemNode(blogsSection3446sLinkVisible, blogsSection3446sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.blogDetails"} {...(typeof blogsSection3446sLinkProps === "function" ? blogsSection3446sLinkProps(item) : (blogsSection3446sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(blogsSection3446sImageVisible, blogsSection3446sImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "blogs"} className={item.imageWithBasePath0ClassName ?? "img-fluid blog-img"} {...(typeof blogsSection3446sImageProps === "function" ? blogsSection3446sImageProps(item) : (blogsSection3446sImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        <div className={item.div0ClassName3 ?? "blog-date"}>
                                            {item.div0Text}
                                            <span>{item.span0Text}</span>
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        <div className={item.div0ClassName4 ?? "blog-author"}>
                                            <span className={item.span0ClassName ?? "badge"}>{item.span0Span0Text}</span>
                                            <div className={item.div0ClassName5 ?? "author"}>
                                                <div className={item.div0ClassName6 ?? "avatar avatar-sm rounded-circle"}>
                                                    {renderItemNode(blogsSection3446sImageVisible, blogsSection3446sImageRenderer, item, (
                                                        <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "patient"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid img-1"} {...(typeof blogsSection3446sImageProps === "function" ? blogsSection3446sImageProps(item) : (blogsSection3446sImageProps ?? {}))} {...(typeof divDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </div>
                                                {renderItemNode(blogsSection3446sLinkVisible, blogsSection3446sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "#"} className={item.link0ClassName ?? "link"} {...(typeof blogsSection3446sLinkProps === "function" ? blogsSection3446sLinkProps(item) : (blogsSection3446sLinkProps ?? {}))} {...(typeof divDiv0Div1Div0Div0Link0LinkProps === "function" ? divDiv0Div1Div0Div0Link0LinkProps(item) : (divDiv0Div1Div0Div0Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </div>
                                        </div>
                                        {renderItemNode(blogsSection3446sH3Visible, blogsSection3446sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogsSection3446sH3Props === "function" ? blogsSection3446sH3Props(item) : (blogsSection3446sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {" "}
                                                {renderItemNode(blogsSection3446sLinkVisible, blogsSection3446sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href2 ?? "all_routes.blogDetails"} {...(typeof blogsSection3446sLinkProps === "function" ? blogsSection3446sLinkProps(item) : (blogsSection3446sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ),
                        blogsSection3446sItemWrapper,
                        blogsSection3446sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeElevenBlogsSectionGenerated;
